import { createAction } from 'typesafe-actions';
import type { TableViewType } from '../../components';

export type NftTableViewId =
  | 'accountNftTokens'
  | 'accountNftCollections'
  | 'contractPackageNftTokens'
  | 'contractPackageOwnedNfts';

export type TableViewId = 'transactions' | NftTableViewId;

export const NFT_TABLE_VIEW_IDS: NftTableViewId[] = [
  'accountNftTokens',
  'accountNftCollections',
  'contractPackageNftTokens',
  'contractPackageOwnedNfts',
];

export const setTableViewType = createAction('SET_TABLE_VIEW_TYPE')<{
  tableId: TableViewId;
  viewType: TableViewType;
}>();
